import React from 'react';

import { Flex } from '@skippay/core/components/Flex';
import Loader from '@skippay/core/components/Loader';

function InSSRLoader(props: { children: JSX.Element }): JSX.Element {
	return typeof window === 'undefined' ? (
		<Flex variant="row" align="center" css={{ height: '100vh' }}>
			<Loader fullSize />
		</Flex>
	) : (
		props.children
	);
}
export default InSSRLoader;
